import { Typography } from '@/components/ui/typography'
import { useFormContext } from '@/lib/form-contexts'

const PREFIX = 'pages./.blocks.header.brand.0'
const name = (str) => `${PREFIX}.${str}`

export default function LogoDisplayForm({ showLogoSizePreview = false }) {
  const form = useFormContext()

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Typography variant="h4">Header Logo Size</Typography>
        <Typography variant="supporting">
          Adjust how tall your logo appears in the storefront header.
        </Typography>
      </div>

      <form.AppField name={name('props.logoMaxHeightPx')}>
        {(field) => (
          <div
            className={
              showLogoSizePreview
                ? 'grid grid-cols-1 gap-5 md:grid-cols-[minmax(0,1fr)_minmax(8rem,14rem)]'
                : 'max-w-xl'
            }
          >
            <field.SliderInput label="Logo Height" step={1} min={16} max={400} unit="px" />
            {showLogoSizePreview ? (
              <div
                className="flex w-full items-center justify-center rounded-xl bg-action px-4 text-lg text-action-foreground"
                style={{ height: `${field.state.value}px` }}
              >
                Logo Preview
              </div>
            ) : null}
          </div>
        )}
      </form.AppField>
    </div>
  )
}
